export const LOCALE:string = 'es-ar';


export {};